import React, { FunctionComponent, useEffect, useState } from 'react';

import classnames from 'classnames';
import Button from 'react-bootstrap/Button';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownMenu from 'react-bootstrap/DropdownMenu';
import DropdownToggle from 'react-bootstrap/DropdownToggle';
import { useTranslation } from 'react-i18next';

import 'core/actions-menu/ActionsMenu.scss';
import { ButtonVariant, Size } from 'core/util/Bootstrap';

interface Props {
    children: React.ReactNode;
    className?: string;
    rotation?: 'horizontal' | 'vertical';
    disabled?: boolean;
}

const ActionsToggle = React.forwardRef(({ children, onClick, disabled }: any, ref: any) => {
    const { t } = useTranslation('common');

    return (
        <Button
            className="r4e-actions-menu-toggle"
            variant={ButtonVariant.Default}
            aria-label={t('ACTIONS')}
            size={Size.Small}
            ref={ref}
            onClick={(e): void => {
                e.preventDefault();
                e.stopPropagation();
                onClick(e);
            }}
            disabled={disabled}
        >
            {children}
        </Button>
    );
});

export const ActionsMenu: FunctionComponent<Props> = ({ children, className, disabled, rotation = 'horizontal' }) => {
    const [iconClassname, setIconClassname] = useState<string>(rotation);

    useEffect(() => {
        setIconClassname(
            classnames('icon-ellipsis-h', {
                vertical: rotation === 'vertical',
            }),
        );
    }, [rotation]);

    const filteredChildren = React.Children.toArray(children).filter((child) => child !== null);

    if (!React.Children.count(filteredChildren)) {
        return null;
    }

    return (
        <Dropdown className={classnames('r4e-actions-menu', className)} alignRight>
            <DropdownToggle as={ActionsToggle} variant="primary" disabled={disabled}>
                <i className={iconClassname} />
            </DropdownToggle>
            <DropdownMenu renderOnMount rootCloseEvent="mousedown">
                {filteredChildren}
            </DropdownMenu>
        </Dropdown>
    );
};
